export default {
  title: 'Ofertas Comerciais',
  description: 'Cadastre os produtos e serviços que sua empresa vende. Essas ofertas serão usadas pelos perfis de prospecção e pelo Scanner como referência para qualificação e pontuação de candidatos.',
  labels: {
    new: 'Nova oferta'
  },
  form: {
    title: 'Oferta Comercial'
  },
  groups: {
    identification: 'Identificação',
    problemAndOutcome: 'Problema e resultado',
    scope: 'Escopo',
    differentiators: 'Diferenciais',
    commercial: 'Informações comerciais',
    control: 'Controle'
  },
  fields: {
    name: 'Oferta',
    type: 'Tipo',
    shortDescription: 'Descrição curta',
    problemsSolved: 'Problemas que resolve',
    outcomes: 'Resultados entregues',
    scopeIncluded: 'O que está incluído',
    scopeExcluded: 'O que não está incluído',
    differentiators: 'Diferenciais da oferta',
    commercialModel: 'Modelo comercial',
    priceReference: 'Valor de referência',
    active: 'Ativo'
  },
  errors: {
    OFFER_NAME_REQUIRED: 'Informe o nome da oferta.',
    OFFER_NAME_TOO_LONG: 'O nome da oferta deve ter no máximo 160 caracteres.',
    OFFER_TYPE_INVALID: 'Selecione um tipo de oferta válido.',
    OFFER_DESCRIPTION_REQUIRED: 'Informe uma descrição curta da oferta.',
    OFFER_COMMERCIAL_MODEL_INVALID: 'Selecione um modelo comercial válido.',
    OFFER_ACTIVE_INVALID: 'O estado ativo da oferta é inválido.',
    ck_offers_name_not_blank: 'Informe o nome da oferta.',
    ck_offers_offer_type: 'Selecione um tipo de oferta válido.',
    ck_offers_short_description_not_blank: 'Informe uma descrição curta da oferta.',
    ck_offers_commercial_model: 'Selecione um modelo comercial válido.',
    OFFER_CAPACITY_EXCEEDED: 'Você atingiu o limite de Offers cadastradas do seu plano. Offers desativadas também ocupam uma vaga: exclua uma Offer que não usa mais ou amplie o plano.',
    OFFER_CAPACITY_UNAVAILABLE: 'Não foi possível confirmar quantas Offers o seu plano permite cadastrar. Tente novamente em instantes.',
    OFFER_CAPACITY_NOT_CONTRACTED: 'Seu plano ainda não define a quantidade de Offers que podem ser cadastradas. Fale com o suporte para configurar.',
    offer_registration_capacity_exceeded: 'Você atingiu o limite de Offers cadastradas do seu plano. Offers desativadas também ocupam uma vaga: exclua uma Offer que não usa mais ou amplie o plano.'
  }
};
